export function getCreateNextAppCommand(packageManager: string) {
  switch (packageManager) {
    case 'npm':
      return `npx create-next-app`
    case 'yarn':
      return `npx create-next-app`
    default:
      return `${packageManager} create next-app`
  }
}

export function getNpxCommand(packageManager: string, command: string) {
  switch (packageManager) {
    case 'pnpm':
      return `pnpm dlx ${command}`
    case 'bun':
      return `bunx --bun ${command}`
    default:
      return `npx ${command}`
  }
}

export function getPackageRunner(packageManager: string) {
  switch (packageManager) {
    case 'pnpm':
      return `pnpm dlx`
    case 'bun':
      return `bunx --bun`
    default:
      return `npx`
  }
}
